import type { ReactElement } from 'react';
import type { FieldProps } from '@rjsf/utils';
import { MenuBuilderCore, type MenuItem } from './MenuBuilderCore';
import { getMenuItemErrors } from './menuItemErrors';

const normalizeItems = (items: MenuItem[]): MenuItem[] =>
  items.map((item) => {
    if (item.kind === 'group') {
      return {
        ...item,
        links: item.links.map((link) => ({ ...link, isReadOnly: link.isReadOnly ?? false })),
      };
    }
    return { ...item, isReadOnly: item.isReadOnly ?? false };
  });

// Implemented as a field rather than a widget: rjsf only passes `errorSchema`
// (per-item validation errors) to fields, never to custom array widgets.
export const MenuBuilderField = (props: FieldProps<MenuItem[]>): ReactElement => {
  const { formData, onChange, disabled, readonly, errorSchema, fieldPathId } = props;
  const items = formData ?? [];

  return (
    <MenuBuilderCore
      items={items}
      onChange={(next) => onChange(normalizeItems(next), fieldPathId.path)}
      ro={disabled || readonly}
      errors={errorSchema?.__errors ?? []}
      itemErrors={getMenuItemErrors(items, errorSchema)}
    />
  );
};
